import { oneTimesUpdate } from "@domain/coupons"
import { useQuery } from "@tanstack/react-query"
import { OneTimesType } from "__generated__/graphql"

import type { LivePrompt } from "./livePrompts"

export function useLivePrompts() {
  return useQuery({
    queryKey: ["ai-flow-prompts"],
    queryFn: async () => {
      const response = await oneTimesUpdate({
        type: OneTimesType.GetAllAiPrompts,
        metaData: {}
      })
      if (!response.isSuccess || !response.data) {
        throw new Error(String(response.errorMessage || "Promptlar alınamadı"))
      }
      return (response.data.data || []) as LivePrompt[]
    }
  })
}
